export default "__VITE_ASSET__f6i0TnKC__"